module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "CONTRACT",
      "title": "合同管理",
      "group-name": "员工关系"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d66f6d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/smartHr/SmartHrContract.vue
// module id = 1886
// module chunks = 8